import { Container, ContainerProps } from '@mantine/core';
import classes from './nli-container.module.css';

function NliContainer({ children, ...props }: ContainerProps) {
    return <Container
        bg="white"
        p="20px"
        w="100%"
        {...props}
        style={{ borderRadius: '23px', boxShadow: 'rgba(29, 25, 58, 20%) 0px 0px 6px', ...props.style }}
    >
        {children}
    </Container>;
}

function NliSquaredContainer({ children, size = 250, ...props }: ContainerProps) {
    return <Container
        mih={250}
        size={size}
        bg="white"
        p="20px"
        w="100%"
        {...props}
        style={{ borderRadius: '23px', boxShadow: 'rgba(29, 25, 58, 20%) 0px 0px 6px', ...props.style }}
    >
        {children}
    </Container>;
}

export { NliContainer, NliSquaredContainer };